import { authPost } from "../http_client.js";
import { getContentConfig } from "./player.requests.js";
import type { CumulativeBoosterID } from "../../cumulative_boosters/cumulative_booster_id.js";
import type {
  BoostersPropertiesConfigDto,
  BoostersPricesConfigDto,
  ConsumeBoosterRequest,
  ConsumeBoosterResponse,
  PurchaseBoosterRequest,
  PurchaseBoosterResponse,
  TutorialBoosterRequest,
  TutorialBoosterResponse,
} from "../dto/cumulative_boosters.dto.js";

export function getBoostersPropertiesConfig(): Promise<BoostersPropertiesConfigDto>
{
  return getContentConfig<BoostersPropertiesConfigDto>( "boosters_properties" );
}

export function getBoostersPricesConfig(): Promise<BoostersPricesConfigDto>
{
  return getContentConfig<BoostersPricesConfigDto>( "boosters_prices" );
}

export function consumeBooster(
  booster_id: CumulativeBoosterID
): Promise<ConsumeBoosterResponse>
{
  const request: ConsumeBoosterRequest = { booster_id };
  return authPost<ConsumeBoosterResponse>(
    "api/player/me/boosters/consume",
    request
  );
}

export function purchaseBooster(
  booster_id: CumulativeBoosterID,
  offer_id: number
): Promise<PurchaseBoosterResponse>
{
  const request: PurchaseBoosterRequest = { booster_id, offer_id };
  return authPost<PurchaseBoosterResponse>(
    "api/player/me/boosters/purchase",
    request
  );
}

/** Credits the booster's tutorial grant; the server pays it once per booster. */
export function grantTutorialBooster(
  booster_id: CumulativeBoosterID
): Promise<TutorialBoosterResponse>
{
  const request: TutorialBoosterRequest = { booster_id };
  return authPost<TutorialBoosterResponse>(
    "api/player/me/boosters/tutorial",
    request
  );
}
